import { Editor } from '@tiptap/core';
function findLastSafe(items, predicate) {
    if (!items?.length) {
        return undefined;
    }
    const nativeFindLast = items.findLast;
    if (typeof nativeFindLast === 'function') {
        return nativeFindLast.call(items, predicate);
    }
    for(let index = items.length - 1; index >= 0; index -= 1){
        const value = items[index];
        if (predicate(value, index, items)) {
            return value;
        }
    }
    return undefined;
}
const editorProto = Editor.prototype;
if (!editorProto.__dispatchTransactionCompatPatched) {
    editorProto.dispatchTransaction = function dispatchTransactionCompat(transaction) {
        const editor = this;
        if (editor?.view?.isDestroyed) {
            return;
        }
        if (editor?.isCapturingTransaction) {
            if (!editor.capturedTransaction) {
                editor.capturedTransaction = transaction;
                return;
            }
            transaction?.steps?.forEach((step)=>{
                editor.capturedTransaction?.step(step);
            });
            return;
        }
        const applied = editor?.state?.applyTransaction?.(transaction);
        const nextState = applied?.state;
        const transactions = applied?.transactions ?? [];
        if (!nextState || !Array.isArray(transactions)) {
            return;
        }
        const selectionHasChanged = !editor.state.selection.eq(nextState.selection);
        const rootTrWasApplied = transactions.includes(transaction);
        const prevState = editor.state;
        editor.emit('beforeTransaction', {
            editor,
            transaction,
            nextState
        });
        if (!rootTrWasApplied) {
            return;
        }
        editor.view.updateState(nextState);
        editor.emit('transaction', {
            editor,
            transaction,
            appendedTransactions: transactions.slice(1)
        });
        if (selectionHasChanged) {
            editor.emit('selectionUpdate', {
                editor,
                transaction
            });
        }
        const mostRecentFocusTr = findLastSafe(transactions, (tr)=>tr?.getMeta?.('focus') || tr?.getMeta?.('blur'));
        const focus = mostRecentFocusTr?.getMeta?.('focus');
        const blur = mostRecentFocusTr?.getMeta?.('blur');
        if (focus) {
            editor.emit('focus', {
                editor,
                event: focus.event,
                transaction: mostRecentFocusTr
            });
        }
        if (blur) {
            editor.emit('blur', {
                editor,
                event: blur.event,
                transaction: mostRecentFocusTr
            });
        }
        if (transaction?.getMeta?.('preventUpdate') || !transactions.some((tr)=>tr?.docChanged) || prevState.doc.eq(nextState.doc)) {
            return;
        }
        editor.emit('update', {
            editor,
            transaction,
            appendedTransactions: transactions.slice(1)
        });
    };
    editorProto.__dispatchTransactionCompatPatched = true;
}
